<template>
    <div class="p-3">
        <b-card title="Metode Pendaftaran">
            <b-card-text>
                <!-- <b-button variant="primary" class="btn-sm" @click="create_metode_pendaftaran = true"><b-icon icon="plus"></b-icon> Tambah Data</b-button> -->

                <form v-if="create_metode_pendaftaran" class="mt-3">
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">ID</label>
                        <div class="col-lg-6">
                            <b-form-input type="text" v-model="form_metode_pendaftaran.id"></b-form-input>
                        </div>
                    </div>
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Metode Pendaftaran</label>
                        <div class="col-lg-6">
                            <b-form-input type="text" v-model="form_metode_pendaftaran.nama"></b-form-input>
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <div class="col-lg-3 text-lg-end pt-2"></div>
                        <div class="col-lg-6">
                            <b-button class="btn-sm" variant="primary" @click="createMetodePendaftaran">Simpan</b-button>
                            <b-button class="btn-sm" variant="danger" @click="batalFormMetodePendaftaran">Batal</b-button>
                        </div>
                    </div>
                </form>

                <div id="tabledata-metode-pendaftaran" class="mt-3"></div>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: null,
            access_token: null,
            create_metode_pendaftaran: false,
            form_metode_pendaftaran: {
                id: '',
                nama: '',
            },
            table_mnetode_pendaftaran: null,
            metode_pendaftaran: [],
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')

            this.getMetodePendaftaran()
        },
        createMetodePendaftaran() {
            this.$isLoading(true)
            let uri = '/api/create_metode_pendaftaran'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.post(uri, this.form_metode_pendaftaran, headers).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: 'Success!',
                        text: 'Data Berhasil Dibuat!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
                this.batalFormMetodePendaftaran()
                this.getMetodePendaftaran()
                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        batalFormMetodePendaftaran() {
            this.form_metode_pendaftaran = {
                id: '',
                nama: '',
            }
            this.create_metode_pendaftaran = false
        },
        getMetodePendaftaran() {
            this.$isLoading(true)
            let uri = '/api/get_metode_pendaftaran'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                if (response.data.status == 'success') {
                    this.metode_pendaftaran = response.data.metode_pendaftaran

                    let actions = function (cell, formatterParams) {
                        // return '<button id="show" class="btn btn-success btn-sm"><i id="show" class="fa fa-search" aria-hidden="true"></i> show</button>&nbsp;&nbsp;<button id="edit" class="btn btn-warning btn-sm"><i id="edit" class="fa fa-pencil" aria-hidden="true"></i> edit</button>&nbsp;&nbsp;<button id="delete" class="btn btn-danger btn-sm"><i id="delete" class="fa fa-trash" aria-hidden="true"></i> delete</button>'
                        return '<button id="show" class="btn btn-success btn-sm"><i id="show" class="fa fa-search" aria-hidden="true"></i> show</button>&nbsp;&nbsp;<button id="edit" class="btn btn-warning btn-sm"><i id="edit" class="fa fa-pencil" aria-hidden="true"></i> edit</button>'
                    }

                    this.table_mnetode_pendaftaran = new Tabulator('#tabledata-metode-pendaftaran', {
                        layout: 'fitColumns',
                        data: this.metode_pendaftaran,
                        pagination: 'local',
                        paginationSize: 10,
                        paginationSizeSelector:[10, 25, 50, 100, true],
                        height:"100%",
                        columns: [
                            {title: 'ID', field: 'id'},
                            {title: 'nama', field: 'nama'},
                            {title: 'Aksi', field: 'aksi', formatter: actions, headerSort: false, cellClick: this.actionButton}
                        ],
                        rowFormatter: function (row) {
                            var holderEl = document.createElement("div");
                            var tableEl = document.createElement("div");

                            holderEl.style.boxSizing = "border-box";
                            holderEl.style.padding = "10px 30px 10px 10px";
                            holderEl.style.borderTop = "1px solid #333";
                            holderEl.style.borderBotom = "1px solid #333";
                            holderEl.style.background = "#ddd";

                            tableEl.style.border = "1px solid #333";
                            holderEl.id = 'nested-table-' + row.getData().id
                            holderEl.classList.add('hide')

                            holderEl.appendChild(tableEl);

                            row.getElement().appendChild(holderEl);

                            let actions = function (cell, formatterParams) {
                                return '<button id="delete" class="btn btn-danger btn-sm"><i id="delete" class="fa fa-trash" aria-hidden="true"></i> delete</button>'
                            }

                            var subTable = new Tabulator(tableEl, {
                                layout: 'fitColumns',
                                data:row.getData().konfigurasi_loket,
                                columns:[
                                    {title: 'Nama', field: 'loket_pendaftaran.nama'},
                                    {title: 'Prefix', field: 'loket_pendaftaran.prefix'},
                                    {title: 'Nomor Loket', field: 'loket_pendaftaran.nomor_loket'},
                                ]
                            })
                        },
                    })
                }
                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        actionButton(e, cell) {
            let data = cell.getRow().getData()
            let type = e.target.id
            if (type == 'delete') {
                this.$swal.fire({
                    title: 'Perhatian! ',
                    text: 'Data akan dihapus. Yakin?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, hapus!',
                    cancelButtonText: 'Batal'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.deleteMetodePembayaran(data.id)
                    }
                }).catch((error) => {
                    let response = error.response != undefined ? error.response : null
                    if (response) {
                        if (response.status == 401) {
                            localStorage.setItem('access_token', '')
                            localStorage.setItem('user', '')
                            location.href = '/login'
                        }
                    }
                })
            } else if (type == 'show') {
                $('#nested-table-' + data.id).toggleClass('hide')
            } else if (type == 'edit') {
                this.$router.push({ name: 'edit-konfigurasi-loket-pendaftaran-online', params: {id: data.id} }).catch(()=>{})
            }
        },
        deleteMetodePembayaran(id) {
            this.$isLoading(true)
            let uri = '/api/delete_metode_pendaftaran'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            let params = {
                id: id
            }

            this.axios.post(uri, params, headers).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: 'Success!',
                        text: 'Data Berhasil Dihapus!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
                this.getMetodePendaftaran()
                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        }
    } 
}
</script>